import { navigate } from "gatsby-link";
import { useEffect, useState } from "react";
import { PathPageContext } from "../../gatsby-node";
import { trackCustomEvent } from "../utils/analytics";
import useExperiment, { getVariantsFromPercent } from "./useExperiment";

export default function useAbPathRedirect(
  location: Location,
  context: PathPageContext
) {
  const [showLoader, setShowLoader] = useState(true);
  const { abPercent, flow, nextPath, templateId } = context;
  const hasAbPercent = typeof abPercent === "number";
  const isInABTest = useExperiment(
    hasAbPercent ? location.pathname : "",
    getVariantsFromPercent(abPercent)
  );

  useEffect(() => {
    if (isInABTest) {
      setShowLoader(false);
      return;
    }
    if (isInABTest === false && hasAbPercent && nextPath) {
      trackCustomEvent({
        category: "Path",
        action: "Not in AB test - autoproceeding to next step",
        label: `[${templateId}] ${flow}`,
      });
      navigate(nextPath + location.search, { replace: true });
    }
  }, [flow, hasAbPercent, isInABTest, location.search, nextPath, templateId]);
  return hasAbPercent ? showLoader : false;
}
